//navigate.js?v=6.0.43

import events from './event.js';
import imageHelper from './imageHelper.js';
import Storage from './storage.js';
import { textString, buttonString } from './texts.js';
import _ from './translate.js'
import products from './products.js';
import Logger from './logger.js';
import HelpPopup from './HelpPopup.js';
import { getGraphicKind, hasGraphicText } from './textStep.js';

class Navigator {
    customizerTopNavigationDiv = null;
    customizerBottomNavigationDiv = null;
    popupContentDiv = null;
    navigationLabel = null;
    navigationWrapper = null;
    previousButton = null;
    nextButton = null;
    stepWrapper = null;
    navigationSteps = [
        { class: 'startover', title: _('Start over') },
        { class: 'upload', title: _('Upload') },
        { class: 'paper', title: _('Paper') },
        { class: 'presentation', title: _('Presentation') },
        { class: 'size', title: _('Size') },
        { class: 'gfxtext', title: _('Text') },
        { class: 'retouch', title: _('Retouch') },
        { class: 'selectProduct', title: _('Select product') },
        { class: 'gotoProduct', title: _('Goto product') }
    ];
    helpPopupPrevious = null;
    helpPopupNext = null;

    async init(customizerTopNavigationDiv, customizerBottomNavigationDiv, popupContentDiv = null) {
        this.customizerTopNavigationDiv = customizerTopNavigationDiv;
        this.customizerBottomNavigationDiv = customizerBottomNavigationDiv;
        this.popupContentDiv = popupContentDiv;
        if (!this.customizerTopNavigationDiv || !this.customizerBottomNavigationDiv) {
            Logger.error('Navigator not initialized.');
            return;
        }
        // create navigation label
        this.customizerTopNavigationDiv.classList.add('subheader-4', 'mindstore-underlined-title');

        this.navigationLabel = document.createElement('span');
        this.navigationLabel.classList.add('mscp-navigation-label');
        this.navigationLabel.innerHTML = "";
        this.customizerTopNavigationDiv.appendChild(this.navigationLabel);

        this.navigationInfo = document.createElement('span');
        this.navigationInfo.classList.add('mscp-navigation-info');
        this.navigationInfo.innerHTML = mindstore_object.icon.info;
        this.navigationInfo.addEventListener('click', (e) => {
            e.stopPropagation();
            events.trigger('openAdditionalInfoPopup', {
                text_prop_name: this.getActiveStep() + '_info_text'
            });

        });
        this.customizerTopNavigationDiv.appendChild(this.navigationInfo);

        // create navigation wrapper
        this.navigationWrapper = document.createElement('div');
        this.navigationWrapper.classList.add('mscp-navigation-steps-wrapper', 'horizontal-scroll-arrows');
        this.customizerBottomNavigationDiv.appendChild(this.navigationWrapper);

        // Skapa HelpPopup för bakåt-knappen
        this.helpPopupPrevious = new HelpPopup({
            parentElement: this.customizerBottomNavigationDiv,
            textKey: 'back_on_first_step_disabled_helptext',
            defaultText: '',
            horizontalAlign: 'left',
            placement: 'over',
            offsetY: 20,
            offsetX: 8
        });

        this.helpPopupNext = new HelpPopup({
            parentElement: this.customizerBottomNavigationDiv,
            textKey: 'next_step_disabled_helptext',
            defaultText: '',
            horizontalAlign: 'right',
            placement: 'over',
            offsetY: 20,
            offsetX: 8
        });

        // create close wrapper
        // this.closeWrapper = document.createElement('div');
        // this.closeWrapper.classList.add('mscp-close-wrapper', 'mscp-button-label');
        // this.closeWrapper.innerHTML = buttonString('general_close_button', _('Close'));
        // this.closeWrapper.addEventListener('click', (e) => {
        //     e.stopPropagation();
        //     events.trigger('hidePopup');
        // });
        // this.customizerBottomNavigationDiv.appendChild(this.closeWrapper);

        // initialize navigation
        this.updateLabels();
        this.createNavigation();
        this.createV2Footer();

        events.add('currentResolutionGradeUpdated', (newGrade) => {
            const gradeValue = Storage.get('currentResolutionGrade');
            if (!gradeValue) {
                Storage.save('currentResolutionGrade', newGrade);
            }
            this.updateDisabledSteps();
        });
        events.add('updateNavigation', () => {
            this.updateDisabledSteps();
        });
        events.add('changeStep', (step) => {
            if (step === 'next') {
                step = this.getNextStep();
            } else if (step === 'previous') {
                step = this.getPreviousStep();
            }
            if (!step) {
                Logger.warn('No step provided or step not found.');
                return;
            }

            this.setStep(step);
        });
        events.add('newImageLocalSaved', ({ status }) => {
            this.updateDisabledSteps();

            // if (status !== 'converting') {
            //     this.setStep('paper');
            //     events.trigger('showLoadingOverlay', 'paper');
            // }
        });
        events.add('imageUploadStatusChanged', async ({ id, newStatus, originalStatus }) => {
            const activeImageID = Storage.get('activeImageID');

            if (id != activeImageID || newStatus !== 'uploaded') {
                return;
            }

            // När den aktiva bilden är uppladdad, släpp hold och växla till rätt steg
            Logger.log('Navigate: Image upload complete. Moving to appropriate step.');
            events.trigger('setPopupHold', 0); // Släpp hold när uppladdningen är klar

            // Om papper är redan valt, gå till presentation
            if (Storage.get('uploadPaper')) {
                // Shop deep link with a valid presentation too: both are chosen, skip to size.
                const wanted = Storage.get('uploadPresentation') || (await events.trigger('getShopPresentation')).find(Boolean);
                const applied = wanted ? (await events.trigger('applyPresentationPreselect', wanted)).includes(true) : false;
                if (applied) {
                    this.setStep('size');
                } else {
                    this.setStep('presentation');
                    events.trigger('showLoadingOverlay', 'presentation');
                }
            }
            // Annars gå till paper-steget
            else {
                this.setStep('paper');
                events.trigger('showLoadingOverlay', 'paper');
            }

            events.trigger('applyCropBox'); // Se till att beskära bilden nu när den är uppladdad
        });
    }

    updateLabels() {
        const activeStep = this.getActiveStep();
        if (!activeStep) {
            Logger.debug('No active step found, cannot update step information.');
            return;
        }
        this.navigationLabel.innerHTML = textString(activeStep + '_navigation_label', _('Navigation'));
        this.updateV2Footer();
    }

    /**
     * Nytt steg 1: footer with TILLBAKA, four dots (Ladda upp, Storlek, Retusch, Ram) and NÄSTA. It only
     * drives the existing buttons (previousButton / nextButton), so enabling and skipping stay as they
     * were. Shown while the popup has mscp-up2-on (a product of the shop sheet is chosen).
     */
    createV2Footer() {
        if (this.v2Foot || !this.popupContentDiv) return;
        const chev = (dir) => `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${dir === 'l' ? 'm15 18-6-6 6-6' : 'm9 18 6-6-6-6'}"/></svg>`;
        const foot = document.createElement('div');
        foot.className = 'mscp-v2-foot';
        const back = document.createElement('button');
        back.type = 'button';
        back.className = 'mscp-v2-back';
        back.innerHTML = `${chev('l')}<span>TILLBAKA</span>`;
        back.addEventListener('click', (e) => { e.stopPropagation(); this.previousButton?.click(); });
        const dots = document.createElement('div');
        dots.className = 'mscp-v2-dots';
        for (let i = 1; i <= 4; i++) {
            const d = document.createElement('span');
            d.className = 'mscp-v2-dot';
            d.dataset.n = String(i);
            dots.appendChild(d);
        }
        const next = document.createElement('button');
        next.type = 'button';
        next.className = 'mscp-v2-next';
        next.innerHTML = `<span>NÄSTA</span>${chev('r')}`;
        next.addEventListener('click', (e) => { e.stopPropagation(); this.nextButton?.click(); });
        foot.append(back, dots, next);
        this.popupContentDiv.appendChild(foot);
        this.v2Foot = foot;
    }

    updateV2Footer() {
        if (!this.v2Foot) return;
        const stepNo = { startover: 1, upload: 1, paper: 1, presentation: 2, size: 2, gfxtext: 2, retouch: 3, selectProduct: 4, gotoProduct: 4 }[this.getActiveStep()] || 1;
        this.v2Foot.dataset.stepNo = String(stepNo);
        const check = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
        this.v2Foot.querySelectorAll('.mscp-v2-dot').forEach((d) => {
            const n = Number(d.dataset.n);
            d.classList.toggle('done', n < stepNo);
            d.classList.toggle('current', n === stepNo);
            d.innerHTML = n < stepNo ? check : (n === stepNo ? String(n) : '');
        });
    }

    async createNavigation() {


        // create previous button
        this.previousButton = document.createElement('button');
        this.previousButton.classList.add('mscp-nav-button', 'mscp-previous-button', 'left', 'arrow');
        this.previousButton.innerHTML = mindstore_object.icon.arrow_left;
        this.previousButton.addEventListener('click', (e) => {
            e.stopPropagation();

            // clear all help-popup when clicking next or previous
            this.popupContentDiv.querySelectorAll('.help-popup').forEach(popup => popup.style.display = 'none');
            if (this.gotoPreviousStep()) {
                window.Mindstore.DataLayer?.clickEvent('mscp_navigate_previous', this.getActiveStep());
            }
            else {
                // Visa helptext när man inte kan gå bakåt
                if (this.helpPopupPrevious) {
                    this.helpPopupPrevious.toggle(this.previousButton);
                }
            }
        });

        // create steps
        this.stepWrapper = document.createElement('div');
        this.stepWrapper.classList.add('mscp-step-wrapper');
        this.createStepNavigation();

        // create next button
        this.nextButton = document.createElement('button');
        this.nextButton.classList.add('mscp-nav-button', 'mscp-next-button', 'right', 'arrow');
        this.nextButton.innerHTML = mindstore_object.icon.arrow_right;
        this.nextButton.addEventListener('click', (e) => {
            e.stopPropagation();

            // clear all help-popup when clicking next or previous
            this.popupContentDiv.querySelectorAll('.help-popup').forEach(popup => popup.style.display = 'none');
            if (this.gotoNextStep()) {
                window.Mindstore.DataLayer?.clickEvent('mscp_navigate_next', this.getActiveStep());
            }
            else {
                // Visa helptext när man inte kan gå framåt
                if (this.helpPopupNext) {
                    this.helpPopupNext.toggle(this.nextButton);
                }
            }
        });

        // add buttons to navigation div
        this.navigationWrapper.appendChild(this.previousButton);
        this.navigationWrapper.appendChild(this.stepWrapper);
        this.navigationWrapper.appendChild(this.nextButton);
    }

    async createStepNavigation() {
        this.navigationSteps.forEach(async ({ class: stepClass, title }) => {

            // add navigation button
            const button = document.createElement('button');
            button.classList.add(`mscp-${stepClass}-button`, 'mscp-nav-button');
            button.dataset.step = stepClass;
            // button.innerHTML = title;
            button.classList.add('disabled'); // Disable all steps initially, will be enabled based on logic in updateDisabledSteps
            this.stepWrapper.appendChild(button);
            button.addEventListener('click', (e) => {
                e.stopPropagation();
                if (button.classList.contains('disabled') || button.classList.contains('hidden')) {
                    // Logger.warn("Button for step %s is disabled.", stepClass);
                    console.error("Button for step %s is disabled.", stepClass);
                    return; // Do not proceed if the button is disabled
                }
                const newStep = e.target.dataset.step;
                this.setStep(newStep);
            });
        });
    }

    forceNextStep() {
        const nextStep = this.getNextStep();
        if (nextStep) {
            this.setStep(nextStep);
        } else {
            Logger.debug('No next step available or already at the last step.');
        }
    }

    // do the actual step change
    async setStep(newStep) {
        const currentStep = this.getActiveStep();
        // check if forward or backward navigation
        if (currentStep === newStep) {
            Logger.debug('Already on step: %s', newStep);
            return;
        }
        const isForward = this.navigationSteps.findIndex(step => step.class === newStep) >
            this.navigationSteps.findIndex(step => step.class === currentStep);

        // show loading overlay on forward navigation except when going to presentation
        if (isForward && newStep !== 'upload') { // && newStep !== 'presentation' && newStep !== 'upload') {
            events.trigger('showLoadingOverlay', newStep);
        }

        // hold step change until process is done
        events.trigger('setPopupHold', 1);

        // trigger pre step change event
        await events.trigger('preStepChange', currentStep, newStep);

        // deactivate all buttons
        document.querySelectorAll('.mscp-nav-button').forEach((btn) => {
            btn.classList.remove('active');
        });

        // set new active step
        setTimeout(async () => {
            this.popupContentDiv.dataset.activeStep = newStep;
            const button = this.customizerBottomNavigationDiv.querySelector(`.mscp-${newStep}-button`);
            button.classList.add('active');
            Logger.debug('Step changed to: %s', newStep);

            // trigger step changed event
            await events.trigger('stepChanged', newStep);

            this.popupContentDiv.dataset.activeStep = newStep;
            this.updateDisabledSteps();
            this.updateLabels();

            // release hold after step change is done
            events.trigger('setPopupHold', 0);
        }, 300);
    }

    // trigger step change by virtually clicking the button
    triggerStep(stepClass) {
        // this.setStep(stepClass);
        const button = this.customizerBottomNavigationDiv.querySelector(`.mscp-${stepClass}-button`);
        if (button) {
            if (!button.classList.contains('disabled')) {
                button.click();
            } else {
                console.error("%s is disabled.", stepClass);
            }
        }
        else {
            console.error("No button found for step: %s", stepClass);
        }
    }
    getActiveStep() {
        return this.popupContentDiv.dataset.activeStep;
    }
    getActiveButton() {
        return this.customizerBottomNavigationDiv.querySelector('.mscp-nav-button.active');
    }
    getNextStep() {
        const activeStep = this.getActiveStep();
        const currentIndex = this.navigationSteps.findIndex(step => step.class === activeStep);
        if (currentIndex >= 0 && currentIndex < this.navigationSteps.length - 1) {
            let newStep = this.navigationSteps[currentIndex + 1]?.class;
            if (newStep === 'gfxtext' && !getGraphicKind()) {
                newStep = this.navigationSteps[currentIndex + 2]?.class; // looks without text: size -> retouch
            }
            return newStep;
        }
        return null; // No next step available
    }

    gotoNextStep() {
        const nextStep = this.getNextStep();
        if (!this.isStepEnabled(nextStep)) {
            // Logger.warn('Next step is not enabled or does not exist.');
            return false;
        }

        // if next step is enabled, proceed
        if (nextStep) {
            events.trigger('showLoadingOverlay', nextStep);
            this.triggerStep(nextStep);
            return true;
        } else {
            // Logger.warn('No next step available or already at the last step.');
            return false;
        }
    }
    getPreviousStep() {
        const activeStep = this.getActiveStep();
        const currentIndex = this.navigationSteps.findIndex(step => step.class === activeStep);
        if (currentIndex > 0) {
            const prev = this.navigationSteps[currentIndex - 1].class;
            if (prev === 'gfxtext' && !getGraphicKind()) {
                return this.navigationSteps[currentIndex - 2].class; // looks without text: retouch -> size
            }
            return prev;
        }
        return null; // No previous step available
    }
    gotoPreviousStep() {
        const prevStep = this.getPreviousStep();
        if (!this.isStepEnabled(prevStep)) {
            // Logger.warn('Previous step is not enabled or does not exist.');
            return false;
        }

        if (prevStep) {
            this.triggerStep(prevStep);
            return true;
        } else {
            // Logger.warn('No previous step available or already at the first step.');
            return false;
        }
    }
    disableStep(stepClass) {
        const button = this.customizerBottomNavigationDiv.querySelector(`.mscp-${stepClass}-button`);
        if (button) {
            button.classList.add('disabled');
        } else {
            console.error("No button found for step:", stepClass);
        }
    }
    enableStep(stepClass) {
        const button = this.customizerBottomNavigationDiv.querySelector(`.mscp-${stepClass}-button`);
        if (button) {
            button.classList.remove('disabled');
        } else {
            console.error("No button found for step:", stepClass);
        }
    }
    hideStep(stepClass) {
        const button = this.customizerBottomNavigationDiv.querySelector(`.mscp-${stepClass}-button`);
        if (button) {
            button.classList.add('hidden');
        } else {
            console.error("No button found for step:", stepClass);
        }
    }
    showStep(stepClass) {
        const button = this.customizerBottomNavigationDiv.querySelector(`.mscp-${stepClass}-button`);
        if (button) {
            button.classList.remove('hidden');
        } else {
            console.error("No button found for step:", stepClass);
        }
    }

    isStepEnabled(stepClass) {
        const button = this.customizerBottomNavigationDiv.querySelector(`.mscp-${stepClass}-button`);
        return button && !button.classList.contains('disabled') && !button.classList.contains('hidden');
    }

    isStepActive(stepClass) {
        const button = this.customizerBottomNavigationDiv.querySelector(`.mscp-${stepClass}-button`);
        return button && button.classList.contains('active');
    }

    async updateDisabledSteps(currentStep = null) {
        if (!currentStep) {
            currentStep = this.getActiveStep();
        }
        if (!currentStep) {
            // Not an error: updateDisabledSteps() is also called from event
            // handlers (updateNavigation, newImageLocalSaved,
            // currentResolutionGradeUpdated) that can fire before any step is
            // active — e.g. while the popup is opening or showing the
            // start-over chooser. There is nothing to update yet, and
            // setStep() re-runs this once a step becomes active. Debug-only.
            Logger.debug('updateDisabledSteps: no active step yet, skipping (expected during popup open / start-over).');
            return;
        }
        const activeImage = await imageHelper.getActiveImage(); // Get the active image
        if (!activeImage) {
            this.showStep('upload');
            this.hideStep('paper');
            this.navigationWrapper.classList.toggle('scroll_left', false);
            this.navigationWrapper.classList.toggle('scroll_right', false);
            this.addNextHint();
            return;
        }

        this.hideStep('upload');
        this.showStep('paper');

        const presentation = Storage.get('presentation');
        const paper = Storage.get('paper');
        const size = Storage.get('size');
        const currentResolutionGrade = Storage.get('currentResolutionGrade');
        const size_and_resolution = size && (Number(currentResolutionGrade) >= 2);
        const retouch = Storage.get('retouch');
        const selectProduct = Storage.get('selectProduct');
        switch (currentStep) {
            case 'startover':
                this.enableStep('startover');
                this.disableStep('upload');
                this.disableStep('presentation');
                this.disableStep('paper');
                this.disableStep('size');
                this.disableStep('retouch');
                this.disableStep('selectProduct');
                this.disableStep('gotoProduct');
                break;
            case 'upload':
                this.previousButton.classList.add('disabled');
                this.enableStep('upload');
                if (activeImage) {
                    this.enableStep('paper');
                    (paper) ? this.enableStep('presentation') : this.disableStep('presentation');
                    (presentation) ? this.enableStep('size') : this.disableStep('size');
                    (size) ? this.enableStep('retouch') : this.disableStep('retouch');
                    (size_and_resolution) ? this.enableStep('selectProduct') : this.disableStep('selectProduct');
                    (selectProduct) ? this.enableStep('gotoProduct') : this.disableStep('gotoProduct');
                } else {
                    this.disableStep('paper');
                    this.disableStep('presentation');
                    this.disableStep('size');
                    this.disableStep('retouch');
                    this.disableStep('selectProduct');
                    this.disableStep('gotoProduct');
                }
                break;

            case 'paper':
                this.previousButton.classList.add('disabled');
                this.enableStep('upload');
                this.enableStep('paper');
                (paper) ? this.enableStep('presentation') : this.disableStep('presentation');
                (presentation) ? this.enableStep('size') : this.disableStep('size');
                (size_and_resolution) ? this.enableStep('retouch') : this.disableStep('retouch');
                (retouch) ? this.enableStep('selectProduct') : this.disableStep('selectProduct');
                (selectProduct) ? this.enableStep('gotoProduct') : this.disableStep('gotoProduct');
                break;
            case 'presentation':
                this.previousButton.classList.remove('disabled');
                this.enableStep('upload');
                this.enableStep('paper');
                this.enableStep('presentation');
                (presentation) ? this.enableStep('size') : this.disableStep('size');
                (size_and_resolution) ? this.enableStep('retouch') : this.disableStep('retouch');
                (retouch) ? this.enableStep('selectProduct') : this.disableStep('selectProduct');
                (selectProduct) ? this.enableStep('gotoProduct') : this.disableStep('gotoProduct');
                break;
            case 'size':
                this.previousButton.classList.remove('disabled');
                this.enableStep('upload');
                this.enableStep('paper');
                this.enableStep('presentation');
                this.enableStep('size');
                // TODO: check that not in active crop mode
                (size_and_resolution) ? this.enableStep('retouch') : this.disableStep('retouch');
                (retouch) ? this.enableStep('selectProduct') : this.disableStep('selectProduct');
                (selectProduct) ? this.enableStep('gotoProduct') : this.disableStep('gotoProduct');
                break;
            case 'gfxtext':
                this.previousButton.classList.remove('disabled');
                this.enableStep('upload');
                this.enableStep('paper');
                this.enableStep('presentation');
                this.enableStep('size');
                this.enableStep('gfxtext');
                (size_and_resolution) ? this.enableStep('retouch') : this.disableStep('retouch');
                (retouch) ? this.enableStep('selectProduct') : this.disableStep('selectProduct');
                (selectProduct) ? this.enableStep('gotoProduct') : this.disableStep('gotoProduct');
                break;
            case 'retouch':
                this.previousButton.classList.remove('disabled');
                this.enableStep('upload');
                this.enableStep('presentation');
                this.enableStep('paper');
                this.enableStep('retouch');
                (retouch) ? this.enableStep('selectProduct') : this.disableStep('selectProduct');
                (selectProduct) ? this.enableStep('gotoProduct') : this.disableStep('gotoProduct');
                break;
            case 'selectProduct':
                this.previousButton.classList.remove('disabled');
                this.enableStep('upload');
                this.enableStep('presentation');
                this.enableStep('paper');
                this.enableStep('retouch');
                this.enableStep('selectProduct');
                // TODO: check that image and thumbnail is generated and uploaded
                (selectProduct) ? this.enableStep('gotoProduct') : this.disableStep('gotoProduct');
                break;
            case 'gotoProduct':
                this.previousButton.classList.remove('disabled');
                this.enableStep('upload');
                this.enableStep('presentation');
                this.enableStep('retouch');
                this.enableStep('selectProduct');
                (selectProduct) ? this.enableStep('gotoProduct') : this.disableStep('gotoProduct');
                break;
            default:
                console.error("Unknown step:", currentStep);
                break;
        }
        // Text step (graphic looks only): shown and reachable once the size is set; the steps after it
        // wait until the visitor has written something.
        this.popupContentDiv.dataset.gfx = getGraphicKind() ? '1' : '0';
        if (getGraphicKind()) {
            this.showStep('gfxtext');
            if (currentStep !== 'gfxtext') {
                (size_and_resolution) ? this.enableStep('gfxtext') : this.disableStep('gfxtext');
            }
            if (!hasGraphicText()) {
                this.disableStep('retouch');
                this.disableStep('selectProduct');
                this.disableStep('gotoProduct');
            }
        } else {
            this.hideStep('gfxtext');
            this.disableStep('gfxtext');
        }
        // this.hideAndEnableStep('selectProduct');
        // this.hideAndEnableStep('gotoProduct');

        const prevStep = this.getPreviousStep();
        this.navigationWrapper.classList.toggle('scroll_left', this.isStepEnabled(prevStep));

        const nextStep = this.getNextStep();
        this.navigationWrapper.classList.toggle('scroll_right', this.isStepEnabled(nextStep));

        // Logger.log('>>> Updated disabled steps:', {
        //     currentStep,
        //     activeImage,
        //     presentation,
        //     paper,
        //     size,
        //     currentResolutionGrade,
        //     retouch,
        //     selectProduct
        // });
        this.addNextHint();

    }

    // add small animated hint to next button
    async addNextHint() {

        if (!this.nextButton) return;

        // clear any existing hint
        let nextHint = this.nextButton.querySelector('.mscp-next-hint');
        if (!nextHint) {
            nextHint = document.createElement('span');
            nextHint.classList.add('mscp-next-hint', 'mscp-button-label');
            this.nextButton.prepend(nextHint);
        }
        let prevHint = this.previousButton.querySelector('.mscp-prev-hint');
        if (!prevHint) {
            prevHint = document.createElement('span');
            prevHint.classList.add('mscp-prev-hint', 'mscp-button-label');
            this.previousButton.append(prevHint);
        }
        prevHint.innerHTML = buttonString('navigate_hint_prev');

        const nextStep = this.getNextStep();
        if (!this.isStepEnabled(nextStep)) {
            nextHint.innerHTML = buttonString('navigate_hint_disabled');
        } else {
            const currentProductIds = await products.getAttributeHierarchyProductIDs();
            if (this.getActiveStep() === 'retouch' && currentProductIds && currentProductIds.length === 1) {
                nextHint.classList.add('done');
                nextHint.innerHTML = buttonString('navigate_hint_done');
            }
            else {
                nextHint.innerHTML = buttonString('navigate_hint_next');
            }
        }


        // remove hint when animation is done
        // hint.addEventListener('animationend', () => {
        //     hint.remove();
        // });
    }
}

const nav = new Navigator();
export default nav;